module.exports = __webpack_public_path__ + "static/ga_integration_4-a5619cf10cb396564b96c82547446aed.png";